import axios from "axios";
import { currentUserStore } from "@/stores/currentUser";
import tools from "@/composables/tools";
import { mainStore } from "@/stores/mainStore";
import router from "@/router";
import { User } from "@/interfaces/User";
import { useProfesorStore } from "@/stores/profesorStore";
import { useCoordinadorStore } from "@/stores/coordinadorStore";
import { useAvisoApp } from "@/composables/useAvisoApp";

export default function userAuth() {


	async function loginSupervisionCode(code: string): Promise<void> {
		mainStore().setLoading(true, "Activando supervisión...");
		try {
			const response = await axios.post("supervision/redeem", {
				code,
				app: "galidancia_gest",
			});
			localStorage.setItem("token", response.data.access_token);
			if (response.data.user) {
				localStorage.setItem("user", JSON.stringify(response.data.user));
				currentUserStore().update(response.data.user);
			}
			if (response.data.supervision) {
				localStorage.setItem(
					"supervision",
					JSON.stringify(response.data.supervision)
				);
			} else {
				localStorage.removeItem("supervision");
			}
			mainStore().isLogged = true;
			location.href = "/";
		} catch (error: any) {
			mainStore().setLoading(false);
			tools().toast(
				error?.response?.data?.message ||
					"No se pudo activar el modo supervisión",
				"danger",
				4000
			);
		}
	}

	async function login(u?: string, p?: string, user_id?: number) {
		mainStore().setLoading(true, "Iniciando sesión...")
		try {
			// POST: la contraseña no debe viajar en la query string (logs, historial, Referer).
			const response = await axios.post("login", {
				email: u,
				password: p,
				user_id: user_id,
			});
			localStorage.setItem("token", response.data.access_token);
			location.href = "/";
		} catch (error: any) {
			mainStore().isLogged = false;
			mainStore().setLoading(false);
			router.push({ path: "/login" });
		}
	}

	async function logout(): Promise<void> {
		try {
			tools().setLog("Cerrando sesión", "info");
			mainStore().setLoading(true, "Cerrando sesión...");
			
			// Llamar al endpoint de logout en el backend
			await axios.post("logout");
			
			// Limpiar datos locales
			useAvisoApp().resetAndStop();
			localStorage.removeItem("token");
			localStorage.removeItem("user");
			localStorage.removeItem("supervision");
			currentUserStore().$reset();
			mainStore().isLogged = false;
			
			// Redirigir al login
			location.href = "/login";
		} catch (error) {
			console.error("Error al cerrar sesión:", error);
			// Aunque falle el endpoint, limpiamos localmente
			useAvisoApp().resetAndStop();
			localStorage.removeItem("token");
			localStorage.removeItem("user");
			localStorage.removeItem("supervision");
			currentUserStore().$reset();
			mainStore().isLogged = false;
			location.href = "/login";
		} finally {
			mainStore().setLoading(false);
		}
	}

	async function checkEmailTlf(email_tlf: string): Promise<any> {
		try {
			const response = await axios.get("checkEmailTlf", {
				params: {
					email: email_tlf,
				},
			});
			return response.data;
		} catch (error) {
			tools().toast(
				"Error en el sistema de autenticación. Consulta con el administrador #145",
				"danger",
				5000
			);
		}
	}

	/*registra a una entidad que no existe como usuario del sistema*/
	async function registerFromEntidad(
		phone_email: string,
		pw: string,
		entidad_id: number
	) {
		try {
			await axios.get("registerFromEntidad", {
				params: {
					email: phone_email,
					pw: pw,
					entidad_id: entidad_id,
				},
			});
			login(phone_email, pw);
		} catch (error) {
			tools().toast(
				"No hemos podido registrarte. Consultao con el administrador #146",
				"danger",
				5000
			);
		}
	}

	/* Devuelve true o false si tiene o no acceso al recurso basandose en los permisos. Buscamos los permisos en localstorage */
	function can(permission: string): boolean {
		const user = localStorage.getItem("user");
		if (user) {
			const parsedUser = JSON.parse(user);
			try {
				const permissions = Object.values(parsedUser.permissions);
				if (!permissions.includes(permission)) return false
				else return true
			} catch (error) {
				return false
			}

		}
		return false;
	}




	/* Devuelve true o false si tiene o no el role */
	function hasRole(role: string): boolean {
		try {
			const fromStore = currentUserStore().user
			const parsedUser = fromStore
				?? (() => {
					const raw = localStorage.getItem("user")
					return raw ? JSON.parse(raw) : null
				})()

			if (!parsedUser?.roles) return false

			const roles = Object.values(parsedUser.roles).map((r: any) =>
				typeof r === 'string' ? r : (r?.name ?? '')
			)

			return roles.includes(role)
		} catch (error) {
			return false
		}
	}



	/* devuelve true o false si hay algun usuario logeado */
	async function isLogged(): Promise<boolean> {
		const response = await axios.get('isLogged')
		return response.data
	}

	async function getPermissions(): Promise<any> {
		try {
			const response = await axios.get('permissions')
			return response.data
		} catch (error) {
			tools().toast('No se pudo cargar los permisos', 'danger', 5000)
		}
	}

	async function getCurrentUser(): Promise<User> {
		try {
			const response = await axios.get('currentUser')
			// Actualizar el store de Pinia directamente
			currentUserStore().update(response.data);
			return response.data
		} catch (error) {
			tools().toast('No se pudo cargar el usuario actual', 'danger', 5000)
			return {} as User
		}

	}

	return {
		login,
		logout,
		can,
		isLogged,
		checkEmailTlf,
		registerFromEntidad,
		getPermissions,
		getCurrentUser,
		hasRole,
		loginSupervisionCode,
	};
}
